import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import sectionsProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import {
  depthFilter,
  heightFilterWithSizeLabel,
  widthFilter
} from 'rangeConfig/shared/filters/configFilters';
import * as R from 'ramda';
import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { default as Black } from '../../ui/Colors/icons/black.js';
import { default as GreyGreen } from '../../ui/Colors/icons/grey_green.js';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import { getMarketProducts } from 'ducks/products';
import store from 'ducks/configureStore';
import { hasInsertsOfMatchingWidthAndDepth } from 'rangeConfig/bror/filters/mainMenuProductFilter';
import { ChangeDepthFilter, ChangeHeightFilter } from '../../widgets/changeSize/ChangeSizeFilter';
import ChangeColorFilter from 'rangeConfig/shared/widgets/ChangeColorFilter/ChangeColorFilter';

const DesktopSectionFilter = R.pipe(withCategoryFilter(['sections']));

const BlackSectionSwiper = R.pipe(withCategoryFilter(['sectionBlack']));
const GreyGreenSectionSwiper = R.pipe(withCategoryFilter(['sectionGreyGreen']));

const shouldHideChangeColorFilter = () => {
  const productsInMarket = getMarketProducts(store.getState());
  const sectionsInMarket = productsInMarket.filter(p => p.type === ProductType.BROR_SECTION);
  const sectionsHavingMatchingInserts = hasInsertsOfMatchingWidthAndDepth(sectionsInMarket);
  const distinctColors = sectionsHavingMatchingInserts.reduce<ProductDesign[]>(
    (colorsFound, section) =>
      colorsFound.includes(section.design) ? colorsFound : [...colorsFound, section.design],
    []
  );

  return distinctColors.length < 2;
};

const widgets = {
  desktop: [
    {
      id: 'change-frame-color',
      component: ChangeColorFilter,
      hidden: shouldHideChangeColorFilter
    },
    {
      id: 'change-section-size-depth',
      component: ChangeDepthFilter
    },
    {
      id: 'change-section-size-height',
      component: ChangeHeightFilter
    },
    {
      id: 'sections-product-list',
      component: DesktopSectionFilter(withProducts(ProductList, sectionsProductListConfig))
    }
  ],
  mobile: [
    {
      id: `frame-color-black`,
      component: BlackSectionSwiper(withProducts(ProductSwiper, sectionsProductListConfig)),
      title: 'storageone.colorBlack',
      icon: Black,
      iconColor: '#353535'
    },
    {
      id: `frame-color-grey-green`,
      component: GreyGreenSectionSwiper(withProducts(ProductSwiper, sectionsProductListConfig)),
      title: 'storageone.colorGreyGreen',
      icon: GreyGreen,
      iconColor: '#738273'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListSectionsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: [heightFilterWithSizeLabel, widthFilter, depthFilter],
  widgets: widgets[platform]
};

export default mainMenu;
